import React from 'react';
import { useCallback } from 'react';
import styled from 'styled-components';
import {
    FileImageOutlined,
    DownloadOutlined,
} from '@ant-design/icons';
import { Button, Popover } from 'antd';

const FileDetailsPopup = styled.div`
`;

const UploadDetailsLabel = styled.div`
    font-size: 12px;
    margin: auto;
    width: 100%;
`;

const UploadDetailsValue = styled.div`
    font-size: 12px;
    font-family: 'RingSans', Helvetica, Arial, sans-serif;
    font-weight: 500;
    margin: 0px auto 10px auto;
    width: 100%;
`;

const FileDetailsHeader = styled.div`
    color: #1890ff;
`;

const ButtonWrapper = styled.div`
`;

const OpenAttachmentText = styled.span`
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    whiteSpace: nowrap;
    width: 100%;
`;

type DownloadAttachmentButtonProps = {
    caseId: string;
    uploadId: string;
    fileName: string; // legacy support
    fileId?: string; // multi-file support
    multiFile: boolean;
    disabled?: boolean;
};

const FileWrapper = styled.div`
`;

export function DownloadAttachmentButton (props: DownloadAttachmentButtonProps) {
    const {
        caseId,
        uploadId,
        fileName,
        fileId,
        multiFile,
        disabled = false,
    } = props;

    const downloadFile = useCallback(async () => {
        const fileViewerUrl = new URL('/file-viewer', document.location.href);
        fileViewerUrl.searchParams.set('caseId', caseId);
        fileViewerUrl.searchParams.set('uploadId', uploadId);
        // multi file support
        if (fileId) {
            fileViewerUrl.searchParams.set('fileId', fileId);
        }
        open(fileViewerUrl, '_blank');
    }, [caseId, uploadId, fileId]);

    const convertedButtonStyle = { border: '1px solid #40A142', color: '#40A142' };

    // Button On-Hover Popup
    const convertedFileDetailsPopup = (
        <FileDetailsPopup>
            <UploadDetailsLabel>
                File Name:
            </UploadDetailsLabel>
            <UploadDetailsValue>
                {fileName}
            </UploadDetailsValue>
        </FileDetailsPopup>
    );
    const fileDetailsHeader = (
        <FileDetailsHeader>
            <FileImageOutlined style={{ marginRight: '5px' }} />
            Details
        </FileDetailsHeader>
    );

    return (
        <FileWrapper>
            <ButtonWrapper>
                {/* Converted File Download Button */}
                <Popover content={convertedFileDetailsPopup} title={fileDetailsHeader}>
                    <Button
                        type='default'
                        disabled={disabled}
                        onClick={downloadFile}
                        icon={<DownloadOutlined style={{ verticalAlign: '0.125em' }} />}
                        style={{
                            ...convertedButtonStyle,
                            display: 'block',
                            margin: multiFile ? '5px 0px' : '-5px 0px',
                            textAlign: 'left',
                            width: '120px',
                        }}
                    >
                        <OpenAttachmentText>
                            Download
                        </OpenAttachmentText>
                    </Button>
                </Popover>
            </ButtonWrapper>
        </FileWrapper>
    );
}
